import showMessage from "@/utils/showMessage";
import axios from "axios";

const ins = axios.create(); //创建一个axios实例;
ins.interceptors.response.use(function (res) {
  if (res.data.code !== 0) {
    showMessage({ content: res.data.msg, type: "cuowu" });
    return null
  }
  return res
});

export default ins;
